import { ValidationErrorEnum } from './ValidationErrorEnum';
import { ValidationError, WalletValidatorFunction } from './types';

import { US_STATE_CODES } from 'components/Core/Payment/PaymentForm/Card/usStates';

/**
 * Validates US state code
 * Must be a valid 2-letter US state, DC, or territory code
 */
export const stateValidator: WalletValidatorFunction = (state: any) => {
  const errors: ValidationError[] = [];

  if (typeof state !== 'string') {
    errors.push(ValidationErrorEnum.STRING_ERROR_MESSAGE);
    return [false, errors];
  }

  const isValid = US_STATE_CODES.includes(state.toUpperCase());

  if (!isValid) {
    errors.push(ValidationErrorEnum.INVALID_STATE);
  }

  return [errors.length === 0, errors];
};
